export const MEDIA_FRAME_PRESETS = {
  metal: {
    label: 'Metal Frame',
    url: 'https://www.hearthcards.net/newsets/images/metal-frame.webp',
    slice: 47,
    width: 20,
    inset: 0,
    radius: 16,
  },
  golden: {
    label: 'Golden Frame',
    url: 'https://www.hearthcards.net/newsets/images/frame-square.webp',
    slice: 69,
    width: 30,
    inset: 0,
    radius: 16,
  },
};

export const DECK_HOLDER_PRESETS = {
  defaultMetal: {
    label: 'Default',
    top: 'https://www.hearthcards.net/newsets/images/deck-recipes/mpt.webp',
    middle: 'https://www.hearthcards.net/newsets/images/deck-recipes/mpm.webp',
    bottom: 'https://www.hearthcards.net/newsets/images/deck-recipes/mpb.webp',
    width: 405,
    topHeight: 122,
    bottomHeight: 43,
    titleOffset: 32,
    contentInset: 20,
    cardsTopOffset: -20,
  },
};

export const BACKGROUND_PRESETS = [
  { key: 'paper', label: 'Parchment', url: '/newsets/images/backgrounds/paperbg.webp', display: 'contain', tileSize: 50, focus: 'center top' },
  { key: 'stormwind-tiles', label: 'Tiles', url: '/newsets/images/backgrounds/stormwind-tiles.webp', display: 'cover', focus: 'center' },
  { key: 'purple-vertical-wood', label: 'Wood', url: '/newsets/images/backgrounds/purple-vertical-wood.webp', display: 'cover', focus: 'center' },
  { key: 'cushion', label: 'Cushion', url: '/newsets/images/backgrounds/cushion.jpg', display: 'contain', tileSize: 35, focus: 'center top' },
  { key: 'woodbg2', label: 'Wood', url: '/newsets/images/backgrounds/woodbg2.webp', display: 'cover', focus: 'center' },
  { key: 'starry-sky', label: 'Starry Sky', url: '/newsets/images/backgrounds/starry-sky.jpg', display: 'cover', focus: 'center' },
  { key: 'nightsky-bg', label: 'Night Sky', url: '/newsets/images/backgrounds/nightsky-bg.webp', display: 'cover', focus: 'center' },
  { key: 'cloudsky', label: 'Cloud Sky', url: '/newsets/images/backgrounds/cloudsky.webp', display: 'cover', focus: 'center' },
  { key: 'brickwallbg', label: 'Brick Wall', url: '/newsets/images/backgrounds/brickwallbg.webp', display: 'contain', tileSize: 50, focus: 'center top' },
  // { key: 'rocks', label: 'Rocks', url: '/newsets/images/backgrounds/rocks.webp', display: 'contain', tileSize: 50, focus: 'center top' },
  { key: 'bricksbg', label: 'Bricks', url: '/newsets/images/backgrounds/brick555.webp', display: 'contain', tileSize: 10, focus: 'center top' },
];

export const mediaFrameOptions = () => [
  { key: 'none', label: 'No Frame' },
  ...Object.entries(MEDIA_FRAME_PRESETS).map(([key, preset]) => ({ key, label: preset.label })),
];

export const deckHolderOptions = () => Object.entries(DECK_HOLDER_PRESETS)
  .map(([key, preset]) => ({ key, label: preset.label }));

export const backgroundPresetOptions = () => [
  ...BACKGROUND_PRESETS,
  { key: 'custom', label: 'Custom' },
];

export const presetOptionsForField = (group) => {
  if (group === 'mediaFrames') return mediaFrameOptions();
  if (group === 'deckHolders') return deckHolderOptions();
  return backgroundPresetOptions();
};
